import { useEffect, useState } from "react";
import { ServiceFormQuestionUIModel } from "../../../graphql/models";
import { Checkbox, Grid, TextField } from "@material-ui/core";
import { I18NTextField } from "../i18n_text_field";

export interface ServiceSurveyQuestionProps {
  item: ServiceFormQuestionUIModel;
  onUpdate: (item: ServiceFormQuestionUIModel) => void;
}

export function ServiceSurveyQuestion(props: ServiceSurveyQuestionProps) {
  const { item } = props;
  // states
  const [i18n, setI18n] = useState(item.i18n || {});
  const [required, setRequired] = useState(item.required);
  const [index, setIndex] = useState(item.sortIndex);
  const [deleted, setDeleted] = useState(item.deleted);
  // handelrs
  const indexHandler = (value: string) => {
    const n = Number.parseInt(value);
    if (!isNaN(n)) setIndex(n);
  };
  // effect
  useEffect(() => {
    const newItem: ServiceFormQuestionUIModel = {
      i18n,
      required,
      sortIndex: index,
      deleted,
    };
    props.onUpdate(newItem);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [i18n, required, index, deleted]);
  return (
    <Grid container spacing={2}>
      <Grid item md={6}>
        <I18NTextField
          label="Domanda"
          i18nFieldName="title"
          value={i18n}
          onChange={setI18n}
          variant="outlined"
          style={{ width: "100%" }}
        ></I18NTextField>
      </Grid>
      <Grid item md={2}>
        <TextField
          label="Ordinamento"
          variant="outlined"
          type="number"
          value={index}
          onChange={(e) => indexHandler(e.target.value)}
          style={{ width: "100%" }}
        ></TextField>
      </Grid>
      <Grid item md={2}>
        <Checkbox
          checked={required}
          onChange={(e, value) => setRequired(value)}
        ></Checkbox>{" "}
        Risposta Obbligatoria
      </Grid>
      <Grid item md={2}>
        <Checkbox
          checked={deleted}
          onChange={(e, value) => setDeleted(value)}
        ></Checkbox>{" "}
        Cancella!
      </Grid>
    </Grid>
  );
}
